import React from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { bindActionCreators } from 'redux'
import { setUIState, containerIds } from 'redux/modules/ui'
import SearchSort from 'components/molecules/SearchSort'
import {
  type SearchConditionType,
  setSearchCondition,
} from 'redux/modules/search'

function Container(props) {
  function onChange(selectedValue: string) {
    const searchCondition = props.ui.searchCondition || {}
    props.actions.setUIState(containerIds.SEARCH, {
      searchCondition: Object.assign({}, searchCondition, {
        orderBy: selectedValue,
        page: 1,
      }),
    })
    props.actions.setSearchCondition({
      orderBy: selectedValue,
      page: 1,
    })
  }

  return (
    <SearchSort
      onChange={onChange}
      options={[
        {
          value: 'RECOMMEND',
          text: i18n.t('page.shared.sortType.recommend'),
        },
        {
          value: 'PRICE',
          text: i18n.t('page.shared.sortType.price'),
        },
        {
          value: 'CREATED_AT',
          text: i18n.t('page.shared.sortType.createdAt'),
        },
      ]}
      selectedValue={props.search.orderBy || 'RECOMMEND'}
    />
  )
}

function mapStateToProps(state) {
  return state
}
function mapDispatchToProps(dispatch: Dispatch<*>) {
  const bindActions = { setUIState, setSearchCondition }
  return { actions: bindActionCreators(bindActions, dispatch) }
}
export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(Container),
)



// WEBPACK FOOTER //
// ./src/containers/organisms/SearchSort.jsx